import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/global.css';
import './styles/a11y.css';
import './styles/auth.css';
import './styles/dashboard.css';
import './styles/course.css';
import './styles/charts.css';
import './styles/common.css';
import './styles/analytics.css';

// Polyfills for older browsers if needed
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Create the root element to render the app
const root = ReactDOM.createRoot(document.getElementById('root'));

// Temporary: Remove StrictMode for debugging the loop issue
root.render(
  <App />
);

// Once fixed, restore this:
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );